import * as actionTypes from '../constants/actionType';
import * as apiActions from './apiActions';
import * as apiValues from '../constants/apiValues';
import * as helpers from '../helpers';
import {withMapsAndDataProjectsMapLink} from '../utils/mapsAndDataNav';
import {rewritePartnerWithLadotNavLinks, withPartnerWithLadotNavLinks} from '../utils/getInvolvedPartnerForm';


//Action Creators
export const loadMHeaderStart = id => {
  return {type: actionTypes.MHEADER_LOAD_START, id};
};
export const loadMHeaderFail = (error) => {
  console.error(error);
  return {type: actionTypes.MHEADER_LOAD_FAIL, error};
};
export const loadMHeaderSuccess = (data) => {
  return {type: actionTypes.MHEADER_LOAD_SUCCESS, payload: data};
};

export const loadMHeaderProjectStart = () => {
  return {type: actionTypes.MHEADERPROJECT_LOAD_START};
};
export const loadMHeaderProjectFail = (error) => {
  console.error(error);
  return {type: actionTypes.MHEADERPROJECT_LOAD_FAIL, error};
};
export const loadMHeaderProjectSuccess = (data) => {
  return {type: actionTypes.MHEADERPROJECT_LOAD_SUCCESS, payload: data};
};

export const loadMHeaderNavigationStart = () => {
  return {type: actionTypes.MHEADERNAVIGATION_LOAD_START};
};
export const loadMHeaderNavigationFail = (error) => {
  console.error(error);
  return {type: actionTypes.MHEADERNAVIGATION_LOAD_FAIL, error};
};
export const loadMHeaderNavigationSuccess = (data) => {
  return {type: actionTypes.MHEADERNAVIGATION_LOAD_SUCCESS, payload: data};
};

export const loadMListNavStart = (id) => {
  return {
    type: actionTypes.MLISTNAV_LOAD_START,
    id,
  };
};
export const loadMListNavFail = (id, error) => {
  console.error(error);
  return {
    type: actionTypes.MLISTNAV_LOAD_FAIL,
    id,
    error,
  };
};
export const loadMListNavSuccess = (data) => {
  return {
    type: actionTypes.MLISTNAV_LOAD_SUCCESS,
    data,
  };
};
export const menuToggle = (isOpen) => {
  return {
    type: actionTypes.MHEADER_TOGGLE,
    isOpen,
  };
};
export const toggleAllTabs = (isOpen) => {
  return {
    type: actionTypes.MHEADERTAB_TOGGLE_ALL,
    isOpen,
  };
};
export const tabToggle = (id, isOpen) => {
  return {
    type: actionTypes.MHEADERTAB_TOGGLE,
    id,
    isOpen,
  };
};
export const toggleSearch = (isSearchOpen) => {
  return {
    type: actionTypes.MHEADER_TOGGLE_SEARCH,
    isSearchOpen,
  };
};
export const expandedTab = (data) => {
  return {
    type: actionTypes.MHEADER_SET_EXPANDED_TAB,
    data,
  };
};
export const setSearchReturnFocus = (focus) => {
  return {
    type: actionTypes.MHEADER_SET_SEARCH_RETURN_FOCUS,
    focus,
  };
};


export const initMHeader = () => dispatch => {
  dispatch(loadMHeaderStart());

  apiActions
    .loadSingleType(apiValues.nref.mHeader.endpoint)
    .then((result) => {
      const headerDocId = result.documentId || result.id;
      const nmHeader = apiActions.itemSelectCamelCaseKeys(result, apiValues.nref.mHeader.fieldsUsed);

      const normalizeNavRow = (navResult) => {
        const nmListNav = apiActions.itemSelectCamelCaseKeys(navResult, apiValues.nref.mListNav.fieldsUsed);
        if (navResult.navigationLinks) {
          nmListNav.navigationLinks = apiActions.arraySelectCamelCaseKeys(
            navResult.navigationLinks,
            apiValues.nref.navigationLink.fieldsUsed,
          );
        }
        if (navResult.projectTypes) {
          nmListNav.projectTypes = apiActions.arraySelectCamelCaseKeys(
            navResult.projectTypes,
            apiValues.nref.projectType.fieldsUsed,
          );
        }
        const withNavFixes = withPartnerWithLadotNavLinks(withMapsAndDataProjectsMapLink(nmListNav));
        dispatch(loadMListNavSuccess(withNavFixes));
        return withNavFixes;
      };

      const loadNavRows = (navRows) => {
        const rows = Array.isArray(navRows) ? navRows : [];
        const promises = rows.map((raw) => {
          const navId = apiActions.resolveDocumentId(raw);
          const hasNested =
            (Array.isArray(raw.navigationLinks) && raw.navigationLinks.length > 0) ||
            (Array.isArray(raw.projectTypes) && raw.projectTypes.length > 0);
          if (hasNested && (raw.cmsName || raw.CMSName)) {
            return Promise.resolve(normalizeNavRow(raw));
          }
          return apiActions
            .loadEndpoint(apiValues.nref.mListNav.endpoint, navId)
            .then((navResult) => normalizeNavRow(navResult));
        });
        return Promise.allSettled(promises).then((settled) => {
          nmHeader.mListNavs = settled
            .filter((r) => r.status === 'fulfilled')
            .map((r) => r.value);
          dispatch(loadMHeaderSuccess(nmHeader));
        });
      };

      dispatch(loadMHeaderSuccess(nmHeader));

      if ((nmHeader.mListNavs || []).length > 0) {
        loadNavRows(nmHeader.mListNavs);
      } else {
        apiActions
          .loadInverseRelationList(apiValues.nref.mListNav.endpoint, 'mHeaders', headerDocId)
          .then((list) => loadNavRows(list || []))
          .catch((err) => console.error('mHeader nav load', err));
      }
    })
    .catch((err) => dispatch(loadMHeaderFail(err)));

  dispatch(loadMHeaderNavigationStart());
  apiActions
    .loadEndpoint(apiValues.nref.navigationLink.endpoint)
    .then((result) => {
      const navigations = rewritePartnerWithLadotNavLinks(
        apiActions.arraySelectCamelCaseKeys(result, apiValues.nref.navigationLink.fieldsUsed),
      );
      dispatch(
        loadMHeaderNavigationSuccess({
          navigations,
        })
      );
    })
    .catch((err) => dispatch(loadMHeaderNavigationFail(err)));
};

export const headerSearch = queryStr => {
  const suggest = {
    ...apiValues.PROJECT_SUGGEST_QUERY,
    _limit: 4,
    _sort: 'LastSave:desc',
  };
  let projectPromise = helpers.multiFieldContainsQuery(
    queryStr,
    apiValues.nref.project.endpoint,
    ['Title', 'Neighborhoods'],
    'id',
    suggest);
  let navigationLinkPromise = helpers.multiFieldContainsQuery(
    queryStr,
    apiValues.nref.navigationLink.endpoint,
    ['Title'],
    'id',
    {_sort: 'LastSave:desc', _limit: 4, populate: ''});

  return Promise.all([projectPromise, navigationLinkPromise])
    .then(([projects, navigationLinks]) => {
      return {
        projects: projects ? apiActions.arraySelectCamelCaseKeys(projects, apiValues.nref.project.fieldsUsed) : [],
        navigations: navigationLinks
          ? rewritePartnerWithLadotNavLinks(
              apiActions.arraySelectCamelCaseKeys(navigationLinks, apiValues.nref.navigationLink.fieldsUsed),
            )
          : [],
      };
    });
};


